<template lang="pug">
  transition(appear)
    .MapPopup
      .MapPopup-container
        .MapPopup-close(@click="handleClose")
          SvgInline.second(src="cross")

        .MapPopup-type-container
          p.MapPopup-type {{ data.type }}
          .sep
        p.MapPopup-title {{ data.name }}
        .sep
        p.MapPopup-location {{ data.locality != 'null' ? data.locality + ' - ' + data.country : data.country }}
        ButtonSimple(:to="data.url") {{ $t('action.discover') }}

</template>

<script>

import SvgInline from '@/components/SvgInline'
import ButtonSimple from '@/components/common/ButtonSimple'

export default {
  props: {
    data: null
  },
  components: {
    SvgInline,
    ButtonSimple
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" >
.MapPopup
  position absolute
  top 50%
  left 50%
  transform translate(-50%, -50%)
  background-color $beige
  width 300px
  height auto
  padding 5px

  &.v-enter, &.v-leave-to
    opacity 0
    transform translate(-50%, 50%)

  &.v-enter-active, &.v-leave-active
    transition all .6s $ease

  .MapPopup-container
    position relative
    border solid 1px black
    padding 35px 30px

    .MapPopup-close
      position absolute
      width 40px
      height 40px
      border-radius 40px
      background-color black
      border solid 1px $beige
      top -5px
      right -5px
      transform translate(50%, -50%)
      cursor pointer
      transition all .3s $ease

      &:hover
        transform translate(50%, -50%) scale(0.9)

      svg
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        width 40%
        color $beige

    .MapPopup-title
      font-size: 28px
      line-height 30px
      letter-spacing: 1.8px;
      color black
      font-family: 'Sectra Display'
      text-align: center;
      margin auto auto 0px auto

    .MapPopup-type-container
      position absolute
      left 5px
      top 0
      transform rotate(-90deg) translateX(-100%)
      transform-origin 0 0

      .MapPopup-type
        vertical-align middle
        display inline-block
        font-weight 400
        font-size: 12px
        letter-spacing: 2px;

      .sep
        vertical-align middle
        display inline-block
        width: 30px;
        margin 0 15px

    .MapPopup-location
      text-align center
      font-weight 400
      font-size: 12px
      letter-spacing: 2px;

    .ButtonSimple
      margin-top 20px
      font-size 13px
      height 20px !important
      line-height 20px !important
      color black
      padding 10px 25px
      border 1px solid black

      &:before
        background-color black
        right -10px

      &:hover
        transform translateZ(0) perspective(0)
        color white

        &:before
          background-color black

</style>
